
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store , { persistor } from './slices/store';

document.addEventListener(
  'wheel',
  (event) => {
    const el = document.activeElement;
    if (el && el.tagName === 'INPUT' && el.type === 'number' && el === event.target) {
      el.blur();
    }
  },
  { passive: true }
);

document.addEventListener('keydown', (event) => {
  const el = event.target;
  if (
    el &&
    el.tagName === 'INPUT' &&
    el.type === 'number' &&
    (event.key === 'ArrowUp' || event.key === 'ArrowDown')
  ) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
